import { useState, useCallback, useContext, createContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export function useMenuOptions() {
  const [showDataTable, setShowDataTable] = useState(false);
  const toggleDataTable = useCallback(() => {
    setShowDataTable(prevShowDataTable => !prevShowDataTable);
  }, []);
  const closeDataTable = useCallback(() => {
    setShowDataTable(false);
  }, []);
  return {
    showDataTable,
    closeDataTable,
    toggleDataTable
  };
}
export const MenuContext = /*#__PURE__*/createContext({});
export function useMenuData() {
  return useContext(MenuContext);
}
export const MenuProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    showDataTable,
    toggleDataTable,
    closeDataTable
  } = useMenuOptions();
  return /*#__PURE__*/_jsx(MenuContext.Provider, {
    value: {
      showDataTable,
      closeDataTable,
      toggleDataTable
    },
    children: children
  });
};